<script>
import { mapGetters } from "vuex";

import NotProvidedPayablesList from "./Payables/NotProvidedPayablesList";

export default {
  components: {
    NotProvidedPayablesList
  },

  props: {
    ordersNotProvided: {
      type: Array,
      required: true
    },

    isAtBottomOfWindow: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      open: false
    };
  },

  computed: {
    ...mapGetters("user", ["firstName"]),

    countOrdersNotProvided: function() {
      return this.ordersNotProvided.length;
    },

    orderCount: function() {
      return `${this.countOrdersNotProvided} limpeza${
        this.countOrdersNotProvided > 1 ? "s" : ""
      }`;
    }
  },

  filters: {
    formatFirstName(name) {
      if (!name) {
        return "";
      }

      return ", " + name.trim();
    }
  }
};
</script>

<template>
  <transition name="zoom" mode="out-in">
    <div class="root" :class="{ 'modal-z-index': open, 'extra-margin': isAtBottomOfWindow }">
      <div class="header">
        <h2>Olá{{ firstName | formatFirstName }}!</h2>
      </div>

      <div class="schedule">
        <div class="text">
          Onde vamos limpar hoje?
        </div>

        <router-link :to="{ name: 'purchase-flow' }">
          <div class="schedule-button">
            <img src="/static/pin.svg" />

            <span>
              Selecione o endereço da limpeza
            </span>
          </div>
        </router-link>

        <div class="alert" v-if="countOrdersNotProvided">
          <span>
            <img src="/static/exclamation-triangle-solid.svg" />

            Você possui <b>{{ orderCount }}</b> em crédito.
            Entre em contato com o nosso suporte para realizar o reagendamento.
          </span>

          <div class="footer" @click="open = true">
            <span>reagendar limpeza</span>

            <img src="/static/basic/arrow-next.svg" />
          </div>
        </div>
      </div>

      <NotProvidedPayablesList
        v-if="open"
        @close="open = false"
        :orders="ordersNotProvided"
      />
    </div>
  </transition>
</template>

<style scoped>
.root {
  width: calc(100% - 24px - 30px);
  padding: 0px 12px 16px 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: fixed;
  bottom: 10px;
  background-color: #fff;
  border-radius: 2px;
  z-index: 1;
  border: solid 1px #e2e2e2;
  box-shadow: 2px 2px 8px 4px rgba(0, 0, 0, 0.25);
  transition-delay: 500ms;
}

.modal-z-index {
  z-index: 2147483601;
}

.extra-margin {
  margin-bottom: 36px;
}

.header {
  color: #603285;
}

.schedule {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.schedule > .text {
  color: #424242;
  font-size: 16px;
}

.schedule-button {
  padding: 12px 0 12px 16px;
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #e2e2e2;
  border-radius: 2px;
  cursor: pointer;
  animation: pulse 2s infinite;
}

.schedule-button > img {
  height: 20px;
  margin-right: 8px;
}

.schedule-button > span {
  color: #888;
  font-size: 14px;
  font-weight: 400;
}

.alert {
  margin-top: 8px;
}

.alert > span {
  font-size: 14px;
}

.alert > span > img {
  width: 14px;
  height: 12px;
  filter: invert(9%) sepia(94%) saturate(5820%) hue-rotate(316deg)
    brightness(88%) contrast(102%);
}

.alert > span > b {
  font-weight: 400;
  color: #603285;
}

.footer {
  margin-top: 8px;
  padding: 20px 0 4px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-top: solid 1px #e2e2e2;
  cursor: pointer;
  align-items: center;
}

.footer > span {
  font-size: 14px;
  font-weight: 400;
  color: #603285;
}

.footer > img {
  width: 14px;
  height: 14px;
  margin-left: 24px;
}

@media (min-width: 768px) {
  .root {
    width: unset;
    position: relative;
    bottom: unset;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  }

  .header {
    font-size: 20px;
  }

  .footer {
    justify-content: space-between;
  }

  .footer > img {
    margin-left: 0;
  }
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(96, 50, 133, 0.9);
    box-shadow: 0 0 0 0 rgba(96, 50, 133, 0.9);
  }
  70% {
    -moz-box-shadow: 0 0 0 6px rgba(175, 0, 107, 0);
    box-shadow: 0 0 0 6px rgba(175, 0, 107, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(175, 0, 107, 0);
    box-shadow: 0 0 0 0 rgba(175, 0, 107, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/components/Welcome.vue